'use strict';

const STOREFRONT_DOMAIN = 'https://dot-key.myshopify.com/api/2023-10/graphql.json';
const STOREFRONT_TOKEN = '6af1924966e71091c6d3b9e82a3076dd';

// Option names treated as colour swatches — kept in sync with snippets/variant-selector.liquid
const COLOR_OPTION_NAMES = ['color', 'colour', 'flavour', 'flavor'];

const QUIZ_DATA = {
  sunscreen: {
    collectionId: '283344339109',
    triggerText: 'Which sunscreen is good for you?',
    popupHeading: 'Find your perfect Sunscreen <br><strong>in just a few steps...</strong>',
    resultHeading: 'Your Perfect <span>Sunscreen</span> Match Is Here',
    progressImg: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Layer_1_16.png?v=1738315192',
    triggerImg: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Rectangle_1909.png?v=1738059683',
    questions: [
      {
        question: 'Tell Us About Your Skin Type?',
        options: [
          { value: 'Oily', tag: 'Sunscreen_oily', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2708_6bd69b4f-a286-477e-a0c6-b487b3b34145.png?v=1738391766' },
          { value: 'Dry', tag: 'sunscreen_dry', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2712_e9605a38-62c3-4581-bff9-90efeca69494.png?v=1738391982' },
          { value: 'Combination (Oily T-Zone, Rest Feels Dry)', tag: 'sunscreen_combination', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2710_bf127372-d6d5-4f1b-9e09-9aeeadc84204.png?v=1738391910' },
          { value: 'Sensitive', tag: 'sunscreen_sensitive', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2713_10a54df0-c792-4a7a-8242-2f0de23ee8d5.png?v=1738392034' },
          { value: 'Normal', tag: 'sunscreen_normal', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Layer_1.svg?v=1738734863' },
          { value: 'Not sure', tag: 'sunscreen_notsure', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/mage_user-question-mark.svg?v=1738734863' },
        ],
      },
      {
        question: "What's Your Biggest Skin Concern?",
        options: [
          { value: 'Dullness', tag: 'sunscreen_dullness', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2714_1aca006b-b2ac-4058-a6f2-f5da5fb03d30.png?v=1738392221' },
          { value: 'Dark Spots & Pigmentation', tag: 'sunscreen_spots', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2718_276a8c89-ce72-4f8c-9792-4a0a2ecf1294.png?v=1738392479' },
          { value: 'Acne', tag: 'sunscreen_acne', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2715_260fd3ce-450b-4691-8d61-9f38c731cb31.png?v=1738392310' },
          { value: 'Excess Oil', tag: 'sunscreen_oil', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2717_a00217e0-6327-489b-8c1a-18acb08743b1.png?v=1738392460' },
          { value: 'Damaged Skin', tag: 'sunscreen_damaged', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2716_ba111f27-7318-4102-b075-14ba098f7e6f.png?v=1738392385' },
          { value: 'Tanning', tag: 'sunscreen_tan', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2719_2ecac71f-1a2e-4623-91c9-7499a6b78513.png?v=1738392517' },
        ],
      },
      {
        question: 'Share Your Dream Skin Finish With Us!',
        options: [
          { value: 'Dewy', tag: 'Sunscreen_dewy', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2725_6a804632-44ec-4e53-acfe-6bfc67efe64e.png?v=1738392594' },
          { value: 'Natural', tag: 'Sunscreen_natural', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2721_d4889bcc-51d3-41af-84da-f84a9e33af9a.png?v=1738392618' },
          { value: 'Oil-Free', tag: 'sunscreen_oilfree', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2722_4496cccb-6576-44f0-80c3-6fab02391540.png?v=1738392654' },
          { value: 'Matte', tag: 'sunscreen_matte', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2723_120de3ce-1179-4b8c-b61c-d23a51a51c07.png?v=1738392693' },
        ],
      },
    ],
  },
  moisturizer: {
    collectionId: '177428627588',
    triggerText: 'Which Moisturizer is good for you?',
    popupHeading: 'Find Your Perfect Moisturizer<br><strong>in Just Few Steps...</strong>',
    resultHeading: 'Your Perfect <span>Moisturizer</span> Match Is Here',
    progressImg: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/glowing-star-messenger_1_1a082f72-d6f1-401d-a4ae-77134964854e.png?v=1739530801',
    triggerImg: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Rectangle_1909_a8361f0b-5126-435a-8e83-e45339199884.png?v=1739529804',
    questions: [
      {
        question: 'Tell Us About Your Skin Type?',
        options: [
          { value: 'Oily', tag: 'moisturizer_oily', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2708_6bd69b4f-a286-477e-a0c6-b487b3b34145.png?v=1738391766' },
          { value: 'Dry', tag: 'moisturizer_dry', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2712_e9605a38-62c3-4581-bff9-90efeca69494.png?v=1738391982' },
          { value: 'Sensitive', tag: 'moisturizer_sensitive', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2713_a1cc7f6a-e9c9-4fbc-8623-d6187d8eb172.png?v=1739531313' },
          { value: 'Combination (Oily T-zone, rest feels dry)', tag: 'moisturizer_combination', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2710_1.png?v=1739531433' },
          { value: 'Normal', tag: 'moisturizer_normal', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Layer_1.svg?v=1738734863' },
          { value: 'Not sure', tag: 'moisturizer_notsure', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/mage_user-question-mark.svg?v=1738734863' },
        ],
      },
      {
        question: "What's Your Biggest Skin Concern?",
        options: [
          { value: 'Dullness', tag: 'moisturizer_dullness', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2714_1aca006b-b2ac-4058-a6f2-f5da5fb03d30.png?v=1738392221' },
          { value: 'Acne', tag: 'moisturizer_acne', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2715_260fd3ce-450b-4691-8d61-9f38c731cb31.png?v=1738392310' },
          { value: 'Dryness', tag: 'moisturizer_dryness', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2731_9e0c9001-eef2-4f60-9f1b-9aaa7c62deb3.png?v=1739531899' },
          { value: 'Excess Oil', tag: 'moisturizer_oil', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2717_a00217e0-6327-489b-8c1a-18acb08743b1.png?v=1738392460' },
          { value: 'Pigmentation', tag: 'moisturizer_pigmentation', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2718_276a8c89-ce72-4f8c-9792-4a0a2ecf1294.png?v=1738392479' },
          { value: 'Dark Spots', tag: 'moisturizer_spots', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2734_780c0c53-1f72-4cd2-a5d8-31ed8a1c3f8a.png?v=1739532130' },
          { value: 'Aging', tag: 'moisturizer_aging', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2735_bf70fe5c-32f0-43d8-8b16-48024918a143.png?v=1739532252' },
        ],
      },
      {
        question: "What's your Moisturizer Routine?",
        options: [
          { value: 'Day Cream', tag: 'moisturizer_day', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2736_4f5e5f49-88ce-4379-bef2-2f49f1deb789.png?v=1739532622' },
          { value: 'Night Cream', tag: 'moisturizer_night', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2737_1bd55111-e8a0-42fb-9ede-96d1b4e292ac.png?v=1739532684' },
        ],
      },
    ],
  },
  serum: {
    collectionId: '177241063556',
    triggerText: 'Which Serum is good for you?',
    popupHeading: 'Find Your Perfect Serum <br><strong>in Just Few Steps...</strong>',
    resultHeading: 'Your Perfect <span>Serum</span> Match Is Here',
    progressImg: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Layer_1_e1aee793-83e5-449e-a77b-06be4182d93a.png?v=1739352496',
    triggerImg: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Rectangle_1909_7b091143-4f39-4408-96c3-7ea763c4932a.png?v=1739352289',
    questions: [
      {
        question: 'Which Age Group describes you best?',
        options: [
          { value: '18-29 Years', tag: 'serum_age', img: '' },
          { value: '30-39 Years', tag: 'serum_age', img: '' },
          { value: '40-49 Years', tag: 'serum_age', img: '' },
          { value: '50+ Years', tag: 'serum_age', img: '' },
        ],
      },
      {
        question: 'Tell us about your skin type',
        options: [
          { value: 'Oily', tag: 'serum_oily', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2708_6bd69b4f-a286-477e-a0c6-b487b3b34145.png?v=1738391766' },
          { value: 'Dry', tag: 'serum_dry', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2712_e9605a38-62c3-4581-bff9-90efeca69494.png?v=1738391982' },
          { value: 'Sensitive', tag: 'serum_sensitive', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2713_10a54df0-c792-4a7a-8242-2f0de23ee8d5.png?v=1738392034' },
          { value: 'Combination (Oily T-Zone, Rest Feels Dry)', tag: 'serum_combination', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2710_bf127372-d6d5-4f1b-9e09-9aeeadc84204.png?v=1738391910' },
          { value: 'Normal', tag: 'serum_normal', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Layer_1.svg?v=1738734863' },
        ],
      },
      {
        question: "What's your Primary Skin Concern?",
        options: [
          { value: 'Blemishes & Acne Marks', tag: 'serum_acnemark', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2738_1e488da2-a454-4745-a344-db8010c723eb.png?v=1739523719' },
          { value: 'Dullness & Pigmentation', tag: 'serum_dullness', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2739_b795257d-03d0-41ac-be27-38988abc2806.png?v=1739523772' },
          { value: 'Wrinkles & Fine Lines', tag: 'serum_wrinkle', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2740_2512039d-ced3-496e-a9f3-e7f4299b805f.png?v=1739523823' },
          { value: 'Uneven Skin Texture', tag: 'serum_textured', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2741_f44d33bf-aed7-4acc-8000-d9bf0b584bd9.png?v=1739523878' },
          { value: 'Dry & Damaged Skin', tag: 'serum_damaged', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2742_7a338b8f-3177-4b95-a3c3-4bb1cdc6f558.png?v=1739523928' },
          { value: 'Active Acne & Redness', tag: 'serum_activeacne', img: 'https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2744_646aa4c3-9585-4ca4-8872-62b747576601.png?v=1739524031' },
        ],
      },
    ],
  },
};

class CollectionQuiz extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    const quizType = this.dataset.quizType;
    const data = QUIZ_DATA[quizType];
    if (!data) return;

    this._selectedValues = [];
    this._selectedTags = [];
    this._currentStep = 1;
    this._resultsShown = false;
    this._data = data;

    this._buildHTML(data);
    this._bindEvents();
    this._loadQuestion();
  }

  disconnectedCallback() {
    const overlay = document.querySelector('.collection-quiz__overlay');
    if (overlay) overlay.remove();
    document.body.classList.remove('quiz-open');
  }

  _buildHTML({ triggerImg, triggerText, popupHeading, progressImg }) {
    this.innerHTML = `
      <div class="collection-quiz__trigger" data-quiz-trigger>
        <img
          class="collection-quiz__decision-mark"
          src="https://cdn.shopify.com/s/files/1/0361/8553/8692/files/decision-making_1.png?v=1738061351"
          alt=""
          width="37"
          height="37"
          loading="lazy"
        >
        <div class="collection-quiz__inner">
          <div class="collection-quiz__product-img">
            <img src="${triggerImg}" alt="" width="200" height="200" loading="lazy">
          </div>
          <div class="collection-quiz__text">
            <p class="collection-quiz__heading">Not sure,</p>
            <p>${triggerText}</p>
            <div class="collection-quiz__proceed-btn procced__btn" data-quiz-proceed>
              <p>PROCEED &gt;</p>
            </div>
          </div>
        </div>
      </div>

      <div class="collection-quiz__popup" data-quiz-popup>
        <div class="collection-quiz__popup-content">
          <button type="button" class="collection-quiz__close-btn" data-quiz-close aria-label="Close quiz">
            <img
              class="popup-close-btn"
              quiz_name="${this.dataset.quizType}"
              quiz_step="step-1"
              data-quiz-close-meta
              src="https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Layer_1_15.png?v=1738065705"
              alt=""
              width="15"
              height="15"
              loading="lazy"
            >
          </button>
          <div class="collection-quiz__popup-header-wrap" data-quiz-header>
            <h2 class="collection-quiz__popup-title">${popupHeading}</h2>
            <div class="collection-quiz__progress-wrap">
              <img
                class="collection-quiz__progress-img"
                src="${progressImg}"
                alt=""
                width="40"
                height="40"
                loading="lazy"
                data-quiz-progress-img
              >
              <div class="collection-quiz__progress-bar" data-quiz-progress-bar></div>
            </div>
            <div class="collection-quiz__steps">
              <span class="collection-quiz__step is-active" data-quiz-step>Step 1</span>
              <span class="collection-quiz__step" data-quiz-step>Step 2</span>
              <span class="collection-quiz__step" data-quiz-step>Step 3</span>
            </div>
          </div>
          <div class="collection-quiz__body">
            <h3 class="collection-quiz__question" data-quiz-question></h3>
            <p class="collection-quiz__instruction" data-quiz-instruction>Select only 1...</p>
            <div class="collection-quiz__options" data-quiz-options></div>
            <div class="collection-quiz__btn-row">
              <button type="button" class="collection-quiz__prev-btn" data-quiz-prev>
                <img
                  src="https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Vector_256.png?v=1738131414"
                  alt="Previous"
                  width="10"
                  height="10"
                  loading="lazy"
                >
              </button>
              <button type="button" class="collection-quiz__next-btn quiz-next-btn" data-quiz-next disabled>NEXT &gt;</button>
            </div>
            <div class="collection-quiz__results" data-quiz-results></div>
          </div>
        </div>
      </div>
    `;
  }

  _bindEvents() {
    this.querySelector('[data-quiz-proceed]').addEventListener('click', () => this._openQuiz());
    this.querySelector('[data-quiz-close]').addEventListener('click', () => {
      const quizName = this.dataset.quizType;
      const quizStep = this._resultsShown ? 'result' : `step-${this._currentStep}`;

      const closeMeta = this.querySelector('[data-quiz-close-meta]');
      if (closeMeta) {
        closeMeta.setAttribute('quiz_name', quizName);
        closeMeta.setAttribute('quiz_step', quizStep);
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'quiz_close_button',
        quiz_name: quizName,
        quiz_step: quizStep,
      });
      this._closeQuiz();
    });
    this.querySelector('[data-quiz-next]').addEventListener('click', () => this._onNext());
    this.querySelector('[data-quiz-prev]').addEventListener('click', () => this._onPrev());
  }

  _openQuiz() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quiz_proceed_btn',
      quiz_type: this.dataset.quizType,
    });

    this.querySelector('[data-quiz-popup]').classList.add('is-active');
    document.body.classList.add('quiz-open');

    const overlay = document.createElement('div');
    overlay.className = 'collection-quiz__overlay';
    overlay.addEventListener('click', () => this._closeQuiz());
    document.body.appendChild(overlay);

    this._loadQuestion();
  }

  _closeQuiz() {
    this.querySelector('[data-quiz-popup]').classList.remove('is-active');
    document.body.classList.remove('quiz-open');

    const overlay = document.querySelector('.collection-quiz__overlay');
    if (overlay) overlay.remove();

    this._currentStep = 1;
    this._selectedValues = [];
    this._selectedTags = [];
    this._resultsShown = false;

    this._setProgress(1);
    this.querySelector('[data-quiz-header]').classList.remove('hidden');
    this.querySelector('[data-quiz-next]').classList.remove('hidden');
    this.querySelector('[data-quiz-next]').disabled = true;
    this.querySelector('[data-quiz-results]').classList.remove('is-visible');
    this.querySelector('[data-quiz-prev]').classList.remove('is-visible');
    this.querySelector('[data-quiz-instruction]').classList.remove('hidden');
    this.querySelector('[data-quiz-question]').classList.remove('hidden');
    this.querySelector('[data-quiz-options]').classList.remove('hidden');
    this.querySelector('.collection-quiz__btn-row').classList.remove('hidden');

    this._loadQuestion();
  }

  _onNext() {
    if (!this._selectedValues[this._currentStep - 1]) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quiz_selected_options',
      current_step: `step-${this._currentStep}`,
      current_select_value: this._selectedValues.slice(0, this._currentStep).join(', '),
    });

    const { questions } = this._data;
    if (this._currentStep < questions.length) {
      this._currentStep++;
      this._loadQuestion();
      this.querySelector('[data-quiz-prev]').classList.add('is-visible');
    } else {
      this._showResults();
      this.querySelector('[data-quiz-prev]').classList.remove('is-visible');
    }
  }

  _onPrev() {
    if (this._currentStep > 1) {
      this._currentStep--;
      this._loadQuestion();
      if (this._currentStep === 1) {
        this.querySelector('[data-quiz-prev]').classList.remove('is-visible');
      }
    }
  }

  _setProgress(step) {
    const bar = this.querySelector('[data-quiz-progress-bar]');
    const img = this.querySelector('[data-quiz-progress-img]');
    if (!bar || !img) return;

    bar.classList.remove('step-2', 'step-3');
    img.classList.remove('step-2', 'step-3');

    if (step >= 2) { bar.classList.add('step-2'); img.classList.add('step-2'); }
    if (step >= 3) { bar.classList.add('step-3'); img.classList.add('step-3'); }
  }

  _loadQuestion() {
    const { question, options } = this._data.questions[this._currentStep - 1];
    const resultsEl = this.querySelector('[data-quiz-results]');
    resultsEl.classList.remove('is-visible');

    this.querySelector('[data-quiz-question]').textContent = question;
    this.querySelector('[data-quiz-instruction]').textContent = 'Select only 1...';

    const optionsEl = this.querySelector('[data-quiz-options]');
    optionsEl.innerHTML = '';

    options.forEach(({ value, tag, img }) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'collection-quiz__option';
      btn.dataset.value = value;
      btn.dataset.tag = tag;

      if (img) {
        const imgEl = document.createElement('img');
        imgEl.src = img;
        imgEl.alt = value;
        imgEl.width = 41;
        imgEl.height = 35;
        imgEl.loading = 'lazy';
        btn.appendChild(imgEl);
      }

      const span = document.createElement('span');
      span.textContent = value;
      btn.appendChild(span);

      if (this._selectedValues[this._currentStep - 1] === value) {
        btn.classList.add('is-selected');
      }

      btn.addEventListener('click', () => this._onOptionClick(btn, value, tag));
      optionsEl.appendChild(btn);
    });

    this._setProgress(this._currentStep);

    const stepEls = this.querySelectorAll('[data-quiz-step]');
    stepEls.forEach((el, i) => el.classList.toggle('is-active', i < this._currentStep));

    const nextBtn = this.querySelector('[data-quiz-next]');
    nextBtn.disabled = !this._selectedValues[this._currentStep - 1];
    nextBtn.setAttribute('current_step', `step-${this._currentStep}`);
    nextBtn.setAttribute('current_select_value', this._selectedValues.slice(0, this._currentStep).join(', '));
  }

  _onOptionClick(btn, value, tag) {
    this.querySelectorAll('.collection-quiz__option').forEach((o) => o.classList.remove('is-selected'));
    btn.classList.add('is-selected');

    this._selectedValues[this._currentStep - 1] = value;
    this._selectedTags[this._currentStep - 1] = tag;

    const nextBtn = this.querySelector('[data-quiz-next]');
    nextBtn.disabled = false;
    nextBtn.setAttribute('current_step', `step-${this._currentStep}`);
    nextBtn.setAttribute('current_select_value', this._selectedValues.slice(0, this._currentStep).join(', '));
  }

  _showResults() {
    this._resultsShown = true;
    this.querySelector('[data-quiz-header]').classList.add('hidden');
    this.querySelector('[data-quiz-instruction]').classList.add('hidden');
    this.querySelector('[data-quiz-question]').classList.add('hidden');
    this.querySelector('[data-quiz-options]').classList.add('hidden');
    this.querySelector('[data-quiz-next]').classList.add('hidden');
    this.querySelector('[data-quiz-prev]').classList.remove('is-visible');
    this.querySelector('.collection-quiz__btn-row').classList.add('hidden');

    const resultsEl = this.querySelector('[data-quiz-results]');
    resultsEl.classList.add('is-visible');
    resultsEl.innerHTML = '';

    const heading = document.createElement('h3');
    heading.className = 'collection-quiz__results-heading';
    heading.innerHTML = this._data.resultHeading;
    resultsEl.appendChild(heading);

    this._fetchProduct(this._data.collectionId, this._selectedTags, (product) => {
      if (!product) {
        const msg = document.createElement('p');
        msg.textContent = 'Sorry, no products found for your selection.';
        resultsEl.appendChild(msg);
        return;
      }
      this._renderResult(product, resultsEl);
    });
  }

  _fetchProduct(collectionId, tags, callback) {
    const tagFilter = tags.map((t) => `tag:${t}`).join(' AND ');
    const query = `query {
      products(first: 1, sortKey: BEST_SELLING, query: "collection_id:${collectionId} ${tagFilter}") {
        edges {
          node {
            id title handle
            variants(first: 100) {
              edges {
                node {
                  id title
                  priceV2 { amount }
                  compareAtPriceV2 { amount }
                  selectedOptions { name value }
                  image { url(transform: { maxWidth: 600 }) }
                  shadeColors: metafield(namespace: "custom", key: "dnk_shade_colors") { value }
                  variantDisabled: metafield(namespace: "custom", key: "variant_disabled") { value }
                }
              }
            }
            images(first: 1) { nodes { url(transform: { maxWidth: 600 }) } }
          }
        }
      }
    }`;

    fetch(STOREFRONT_DOMAIN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query }),
    })
      .then((res) => res.json())
      .then((data) => {
        const match = data?.data?.products?.edges?.[0]?.node ?? null;
        callback(match);
      })
      .catch(() => callback(null));
  }

  _gidToId(gid) {
    return gid.split('/').pop();
  }

  _colorOption(variant) {
    return variant.selectedOptions.find((o) => COLOR_OPTION_NAMES.includes(o.name.toLowerCase().trim())) ?? null;
  }

  _visibleVariants(product) {
    const all = product.variants.edges.map(({ node }) => node);
    const enabled = all.filter((variant) => variant.variantDisabled?.value !== 'true');

    // If every variant is flagged disabled, still show the product rather than an empty card.
    return enabled.length ? enabled : all;
  }

  _shadeColors(variant) {
    const raw = variant.shadeColors?.value;
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch {
      return [];
    }
  }

  _formatPrice(amount) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(parseFloat(amount));
  }

  _updatePrice(variant, priceEl, comparePriceEl, discountEl) {
    const current = parseFloat(variant.priceV2.amount);
    const compare = variant.compareAtPriceV2 ? parseFloat(variant.compareAtPriceV2.amount) : null;

    priceEl.textContent = this._formatPrice(current);

    if (compare && compare > current) {
      const discount = Math.round(((compare - current) / compare) * 100);
      comparePriceEl.textContent = this._formatPrice(compare);
      comparePriceEl.classList.remove('hidden');
      discountEl.textContent = `(${discount}% OFF)`;
      discountEl.classList.remove('hidden');
    } else {
      comparePriceEl.classList.add('hidden');
      discountEl.classList.add('hidden');
    }
  }

  _renderResult(product, container) {
    const wrapper = document.createElement('div');
    wrapper.className = 'collection-quiz__result-wrapper';

    const variants = this._visibleVariants(product);
    if (!variants.length) return;

    const [firstVariant] = variants;
    const firstColorOpt = this._colorOption(firstVariant);

    const card = document.createElement('div');
    card.className = 'collection-quiz__result-product';

    const link = document.createElement('a');
    link.className = 'collection-quiz__result-link';
    link.href = `/products/${product.handle}`;

    const fallbackImage = product.images.nodes[0]?.url ?? '';

    const img = document.createElement('img');
    img.src = firstVariant.image?.url ?? fallbackImage;
    img.alt = product.title;
    img.width = 500;
    img.height = 500;
    img.loading = 'lazy';
    img.className = 'collection-quiz__result-img';

    const titleEl = document.createElement('h4');
    titleEl.className = 'collection-quiz__result-title';
    titleEl.textContent = product.title;

    link.appendChild(img);
    link.appendChild(titleEl);

    const variantsWrap = document.createElement('div');
    variantsWrap.className = 'collection-quiz__variants-wrap';

    const swatchTitle = document.createElement('span');
    swatchTitle.className = 'collection-quiz__swatch-title';
    swatchTitle.dataset.swatchTitle = '';
    swatchTitle.textContent = firstColorOpt?.value ?? '';

    const variantsContainer = document.createElement('div');
    variantsContainer.className = 'collection-quiz__variants';
    variantsContainer.dataset.resultVariants = '';

    variantsWrap.appendChild(swatchTitle);
    variantsWrap.appendChild(variantsContainer);

    const priceContainer = document.createElement('div');
    priceContainer.className = 'collection-quiz__price-container';

    const priceEl = document.createElement('span');
    priceEl.className = 'collection-quiz__price';
    priceEl.dataset.resultPrice = '';

    const comparePriceEl = document.createElement('s');
    comparePriceEl.className = 'collection-quiz__compare-price hidden';
    comparePriceEl.dataset.resultComparePrice = '';

    const discountEl = document.createElement('span');
    discountEl.className = 'collection-quiz__discount hidden';
    discountEl.dataset.resultDiscount = '';

    priceContainer.appendChild(priceEl);
    priceContainer.appendChild(comparePriceEl);
    priceContainer.appendChild(discountEl);

    const form = document.createElement('form');
    form.dataset.quizAtcForm = '';

    const variantIdInput = document.createElement('input');
    variantIdInput.type = 'hidden';
    variantIdInput.name = 'id';
    variantIdInput.dataset.variantIdInput = '';
    variantIdInput.value = this._gidToId(firstVariant.id);

    const qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '1';

    const propInput = document.createElement('input');
    propInput.type = 'hidden';
    propInput.name = 'properties[is_app]';
    propInput.value = 'true';

    const atcBtn = document.createElement('button');
    atcBtn.type = 'submit';
    atcBtn.className = 'collection-quiz__atc-btn';
    atcBtn.dataset.atcBtn = '';

    const atcText = document.createElement('span');
    atcText.dataset.atcText = '';
    atcText.textContent = 'ADD TO CART';
    atcBtn.appendChild(atcText);

    form.appendChild(variantIdInput);
    form.appendChild(qtyInput);
    form.appendChild(propInput);
    form.appendChild(atcBtn);

    card.appendChild(link);
    card.appendChild(variantsWrap);
    card.appendChild(priceContainer);
    card.appendChild(form);
    wrapper.appendChild(card);

    this._updatePrice(firstVariant, priceEl, comparePriceEl, discountEl);

    // Everything that must follow the chosen variant, in one place so the swatch and
    // pill handlers can never drift apart. Mirrors assets/product-card.js.
    const selectVariant = (variant) => {
      variantIdInput.value = this._gidToId(variant.id);
      img.src = variant.image?.url ?? fallbackImage;
      link.href = `/products/${product.handle}?variant=${this._gidToId(variant.id)}`;
      this._updatePrice(variant, priceEl, comparePriceEl, discountEl);
    };

    // One swatch per distinct option value — a product with color + size would
    // otherwise repeat the same shade once per size variant.
    const renderedColors = new Set();

    for (const variant of variants) {
      const colorOpt = this._colorOption(variant);
      const isFirst = variantsContainer.children.length === 0;

      if (colorOpt) {
        const colorValue = colorOpt.value;
        if (renderedColors.has(colorValue)) continue;
        renderedColors.add(colorValue);

        const safeColor = colorValue.replace(/\s+/g, '_').toLowerCase();
        const shades = this._shadeColors(variant);

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `color_buttons ${safeColor}${isFirst ? ' v_active' : ''}`;
        btn.title = colorValue;
        btn.setAttribute('aria-label', colorValue);
        btn.setAttribute('aria-pressed', String(isFirst));

        // Shade fill comes from the custom.dnk_shade_colors metafield, same source as
        // snippets/variant-selector.liquid. JS only passes the values through — the
        // solid/duo-gradient rules live in collection-quiz-stylesheet.css.
        if (shades.length) {
          btn.style.setProperty('--shade-1', shades[0]);
          if (shades.length >= 2) {
            btn.style.setProperty('--shade-2', shades[1]);
            btn.classList.add('color_buttons--duo');
          }
        }

        btn.addEventListener('click', () => {
          wrapper.querySelectorAll('.color_buttons').forEach((b) => {
            b.classList.remove('v_active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('v_active');
          btn.setAttribute('aria-pressed', 'true');
          swatchTitle.textContent = colorValue;
          selectVariant(variant);
        });

        variantsContainer.appendChild(btn);
      } else {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = `collection-quiz__variant-item${isFirst ? ' is-active' : ''}`;
        item.setAttribute('aria-pressed', String(isFirst));

        const span = document.createElement('span');
        span.textContent = variant.title;
        item.appendChild(span);

        item.addEventListener('click', () => {
          wrapper.querySelectorAll('.collection-quiz__variant-item').forEach((v) => {
            v.classList.remove('is-active');
            v.setAttribute('aria-pressed', 'false');
          });
          item.classList.add('is-active');
          item.setAttribute('aria-pressed', 'true');
          selectVariant(variant);
        });

        variantsContainer.appendChild(item);
      }
    }

    wrapper.querySelector('[data-quiz-atc-form]').addEventListener('submit', (e) => {
      e.preventDefault();
      const variantId = variantIdInput.value;
      const btn = wrapper.querySelector('[data-atc-btn]');
      const btnText = wrapper.querySelector('[data-atc-text]');
      this._addToCart(variantId, btn, btnText);
    });

    container.appendChild(wrapper);
  }

  async _addToCart(variantId, btn, btnText) {
    btn.disabled = true;
    btnText.textContent = 'Adding...';

    const cartDrawer = document.querySelector('cart-drawer');
    const sectionId = cartDrawer?.dataset?.sectionId;
    const sections = sectionId ? [sectionId] : [];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('properties[is_app]', 'true');

    try {
      const data = await CartAPI.add(formData, sections);

      btnText.textContent = 'Added!';

      const optimisticCount = parseInt(document.querySelector('[data-cart-count]')?.dataset?.cartCount ?? '0', 10) + 1;

      publish(PUB_SUB_EVENTS.cartAdd, {
        source: 'collection-quiz',
        sections: data.sections,
        item_count: optimisticCount,
      });

      cartDrawer?.open();

      CartAPI.get()
        .then((cart) => updateCartCount(cart.item_count))
        .catch(() => {});

      setTimeout(() => {
        btnText.textContent = 'ADD TO CART';
        btn.disabled = false;
      }, 2000);
    } catch (error) {
      btnText.textContent = 'Error — Try again';
      btn.disabled = false;
      publish(PUB_SUB_EVENTS.cartError, { source: 'collection-quiz', error });
    }
  }
}

if (!customElements.get('collection-quiz')) {
  customElements.define('collection-quiz', CollectionQuiz);
}
